export default __webpack_public_path__ + "static/media/pic66.70a49b2f.jpg";